import { MaterialButton, css, styled } from '@ezbobdev/ui-widgets-ezbob';

const Button = ({ $isIconButton, ...rest }) => <MaterialButton {...rest} />;

export const MaterialButtonStyled = styled(Button)`
  ${({ $isIconButton }) => css`
    ${
      $isIconButton &&
      `
        min-width: unset;
        padding: 0;
      `
    }
  `}
`;
